import OfferActivity from "./OfferActivity";

export default OfferActivity;